import { t } from "@/i18n-js/instance";
import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import type { TextElement } from "@/react/types/Element";

export const elementToBlock = (element: TextElement): BaseBlock => ({
  id: element.id.toString(),
  type: "FormHeadingBlock",
  props: {
    value: {
      prop: "other",
      type: "string",
      value: element.attributes.value,
    },
    textType: {
      prop: "other",
      type: "select",
      value: element.attributes.text_type || "title",
      options: [
        {
          label: t("builder_ui.prop_type.heading_types.title"),
          value: "title",
        },
        {
          label: t("builder_ui.prop_type.heading_types.subtitle"),
          value: "subtitle",
        },
      ],
    },
  },
  meta: {
    elementType: "text",
    textType: element.attributes.text_type,
    elementId: element.id,
    position: element.position,
    elementableId: element.elementable_id,
    parentElementId: element.parent_element_id,
  },
});
